export enum LATINA_COUNTRY_CODE {
    AR = 'AR',
    BO = 'BO',
    CL = 'CL',
    CO = 'CO',
    CR = 'CR',
    DO = 'DO',
    EC = 'EC',
    GT = 'GT',
    HN = 'HN',
    MX = 'MX',
    NI = 'NI',
    PA = 'PA',
    PE = 'PE',
    PY = 'PY',
    SV = 'SV',
    US = 'US',
    UY = 'UY',
    VE = 'VE'
}

export const LATINA_LIST = [
    'AR',
    'BO',
    'CL',
    'CO',
    'CR',
    'DO',
    'EC',
    'GT',
    'HN',
    'MX',
    'NI',
    'PA',
    'PE',
    'PY',
    'SV',
    'US',
    'UY',
    'VE'
];
